import { isEqual, uniqWith } from 'lodash';

export function uniqObjArrayByMultipleProperties<T extends object>(data: T[], properties: Array<keyof T>) {
  return uniqWith(data, (a, b) => properties.every((property) => isEqual(a[property], b[property])));
}
